<template>
  <img alt="Cargando" class="w-24 h-24 mx-auto" src="/images/loading.svg" v-if="componentReady == 'loading'">
  <div class="py-4 text-white bg-red-500 text-center leading-none" v-else-if="componentReady == 'error'">
    <p class="font-bold mb-2">⚠️ Algo no está bien</p>
    <p class="text-sm">Lo sentimos, pero ocurrió algo extraño y no pudimos cargar nuestras tiendas.<br>Por favor, intenta nuevamente.</p>
  </div>
  <div v-else class="rounded border overflow-hidden">
    <div class="flex flex-col md:flex-row items-stretch">
      <div class="w-full md:w-1/2 lg:w-1/3 py-4 px-8">
        <h2 class="mb-4">Filtrar</h2>
        <div class="mb-2">
          <p class="mb-1"><label for="keyword" class="form-label">Palabra clave</label></p>
          <input type="text" class="form-input" id="keyword" @input="keywordTyped()" v-model="keyword">
        </div>
        <div class="mb-2">
          <p class="mb-1"><label for="state_id" class="form-label">Departamento</label></p>
          <select id="state_id" class="form-input" v-model="stateId">
            <option value="">Cualquiera</option>
            <option :value="state.id" :key="`state-${state.id}`" v-for="state in states">{{ state.name }}</option>
          </select>
        </div>
        <div class="mb-2">
          <p class="mb-1"><label for="city_id" class="form-label">Municipio</label></p>
          <select id="city_id" class="form-input" v-model="cityId">
            <option value="">Cualquiera</option>
            <option :value="city.id" :key="`city-${city.id}`" v-for="city in cities">{{ city.name }}</option>
          </select>
        </div>
        <div class="mb-2">
          <p class="mb-1"><label for="city_id" class="form-label">Tipo</label></p>
          <select id="city_id" class="form-input" v-model="branchType">
            <option value="">Tiendas</option>
            <!-- <option value="branch">Tienda</option> -->
            <option value="service_center">Centro de servicio</option>
          </select>
        </div>
      </div>
      <div class="w-full md:w-1/2 lg:w-2/3 relative">
        <div class="absolute z-10 top-0 left-0 mt-4 ml-4 p-2 leading-none text-main border border-main bg-white text-sm">{{ branches.length }} tienda(s) encontrada(s)</div>
        <img alt="Cargando" class="w-24 h-24 mx-auto" src="/images/loading.svg" v-if="mapReady == 'loading'">
        <div class="py-4 text-white bg-red-500 text-center leading-none" v-else-if="mapReady == 'error'">
          <p class="font-bold mb-2">⚠️ Algo no está bien</p>
          <p class="text-sm">Lo sentimos, pero ocurrió algo extraño y no pudimos cargar la ubicación de nuestras tiendas.<br>Por favor, intenta nuevamente.</p>
        </div>
        <gmap-map
          v-else
          ref="gmap"
          :center="{lat: 13.6644387, lng: -89.2500034}"
          :zoom="13"
          :options="mapOptions"
          class="w-full google-map"
          style="height:480px">
          
          <gmap-marker
            :key="`marker-${i}`"
            :position="{ lat: branch.lat, lng: branch.lng }"
            :clickable="true"
            @click="showBranchDetail(branch)"
            v-for="(branch, i) in branches">
          </gmap-marker>
        </gmap-map>

      </div>
    </div>

    <the-modal
      class="pt-12 lg:pt-0 leading-tight"
      modal-width="extrasmall"
      @close="branchModalShown = false"
      v-if="branchModalShown">
      <div class="text-right py-2 px-2 cursor-pointer hover:text-main" slot="header" @click="branchModalShown = false"><action-icons icon="close" class="inline" /></div>
      <div slot="body" class="px-4 text-center text-sm">
        <img :src="currentBranch.image" class="mx-auto mb-2">
        <p class="font-bold text-lg">{{ currentBranch.name }}</p>
        <p class="mb-2">{{ `${currentBranch.city}, ${currentBranch.state}` }}</p>
        <p>{{ currentBranch.address }}</p>
        <p class="mt-1" v-if="currentBranch.phone != null">{{ currentBranch.phone }}</p>
      </div>
      <div slot="footer" class="py-2"></div>
    </the-modal>
  </div>
</template>
<script>
import {debounce} from '@utilities/Debounce.js';
export default {
  name: 'branches-component',
  data() {
    return {
      branchModalShown: false,
      currentBranch: null,
      loadedResources: 0,
      keyword: '',
      stateId: '',
      cityId: '',
      branchType: '',
      states: [],
      cities: [],
      branches: [],
      mapReady: 'loading',
      componentReady: 'loading',
      mapTheme: [  
        {
          "elementType": "labels.icon",
          "stylers": [{ "visibility": "off" }]
        },
        {
          "featureType": "administrative.land_parcel",
          "stylers": [{ "visibility": "off" }]
        },
        {
          "featureType": "administrative.neighborhood",
          "stylers": [{ "visibility": "off" }]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [{ "visibility": "off" }]
        },
        {
          "featureType": "transit",
          "stylers": [{ "visibility": "off" }]
        }
      ],
      mapOptions: {
        zoomControl: true,
        disableDefaultUI: true,
        clickableIcons: false,
        scrollwheel: false,
        styles: this.mapTheme
      },
    }
  },
  watch: {
    stateId(newVal) {
      this.loadCities();
    },
    cityId(newVal) {
      this.loadBranches();
    },
    branchType(newVal) {
      this.loadBranches();
    }
  },
  methods: {
    loadCities: async function() {
      this.cities = [];
      this.cityId = '';
      try {
        let res = await axios.get(`/tiendas/municipios?state_id=${this.stateId}`);
        let { data } = await res.data;
        this.cities = data;

        this.loadBranches();
      } catch(e) {
        this.componentReady = 'error';
      }
    },
    loadStates: async function() {
      try {
        let res = await axios.get('/tiendas/departamentos');
        let { data } = await res.data;
        this.states = data;
        this.componentReady = 'ready';
      } catch(e) {
        this.componentReady = 'error';
      }
    },
    loadBranches: async function() {
      this.branches = [];
      this.mapReady = 'loading';
      let url = '/tiendas/busqueda-rapida?s=1';

      if (this.keyword != '') {
        url += `&keyword=${this.keyword}`;
      }
      if (this.stateId != '') {
        url += `&state_id=${this.stateId}`;
      }
      if (this.cityId != '') {
        url += `&city_id=${this.cityId}`;
      }
      if (this.branchType != '') {
        url += `&type=${this.branchType}`;
      }

      try {
        let res = await axios.get(url);
        let { data } = await res.data;
        this.branches = data;
        this.mapReady = 'ready';

        if (this.branches.length > 0) {
          this.updateMapBounds();
        }

      } catch(e) {
        this.mapReady = 'error';
      }
    },
    keywordTyped: debounce(function(newVal) {
      this.loadBranches();
    }, 400),
    updateMapBounds() {
      setTimeout(() => {
        this.$refs.gmap.$mapPromise.then((map) => {
          const bounds = new google.maps.LatLngBounds();

          for (let branch of this.branches) {
            bounds.extend({ lat: branch.lat, lng: branch.lng });
          }
          map.fitBounds(bounds);

          let zoomOverride = map.getZoom();
          if (zoomOverride > 19) {
            zoomOverride = 19;
          }
          map.setZoom(zoomOverride);
          map.setOptions({styles: this.mapTheme});

          map.setMapTypeId(google.maps.MapTypeId['ROADMAP']); //HYBRID
          map.setTilt(0);
        });
      }, 500);
    },
    showBranchDetail(branch) {
      this.currentBranch = branch;
      this.branchModalShown = true;
    }
  },
  mounted() {
    this.loadStates();
    this.loadBranches();
  }
}
</script>